var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{staticClass:"tabs",attrs:{"value":_vm.value,"background-color":"transparent","show-arrows":""},on:{"change":_vm.emitInput}},[_c('v-tabs-slider',{attrs:{"color":"#0389e0"}}),_vm._l((_vm.items),function(item,itemIndex){return _c('v-tab',{key:itemIndex},[_vm._t("default",null,null,{ item, itemIndex })],2)}),_vm._t("after-items")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }